import { Injectable } from '@angular/core';
import { ProviderService } from '../models/provider-service.model';
import { Subject } from 'rxjs';
import { ModalService } from 'src/app/modal.service';
import { RecommendedModalComponent } from 'src/app/shared/cart/recommended-modal/recommended-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NewCartService {
  public cart1: ProviderService[] = [];
  public cart2: ProviderService[] = [];

  constructor(private modalService: ModalService) {
    console.log('NewCartService service contructor...');

  }

  getTotal() {

    //console.log('NewCartService getTotal...');

    let total = 0.00;

    for ( let service of this.cart1 ) {
      total += service.regularPrice1;
    }

    for ( let service of this.cart2 ) {
      total += service.regularPrice1;
    }

    return total;

  }

  getSavings() {

    let savings = 0.00;

    for ( let service of this.cart1 ) {
      if ( +service.id % 3 == 1 ) {
        savings += 2;
      }
    }

    for ( let service of this.cart2 ) {
      if ( +service.id % 3 == 1 ) {
        savings += 2;
      }
    }

    return savings;

  }

  addService( service: ProviderService, attendeeIndex: 1|2 ) {

    if (attendeeIndex === 1) {
      this.cart1.push( service );
    }

    if (attendeeIndex === 2) {
      this.cart2.push( service );
    }

    !!service.recommendations && service.recommendations.length>0 && this.modalService.presentModal(RecommendedModalComponent, 'recommended-modal', {service: service});

  }

  reset() {
    this.cart1 = [];
    this.cart2 = [];
  }

  removeService( service: ProviderService, attendeeIndex: 1|2 ) {

    if (attendeeIndex === 1) {

      for (let i = 0; i < this.cart1.length; i++) {

        if ( this.cart1[i].id == service.id ) {
          this.cart1.splice(i, 1);
        }

      }

    }

    if (attendeeIndex === 2) {

      for (let i = 0; i < this.cart2.length; i++) {

        if ( this.cart2[i].id == service.id ) {
          this.cart2.splice(i, 1);
        }
      }
    }
  }

  getCart1() {
    return this.cart1;
  }

  getCart2() {
    return this.cart2;
  }

}